import React, { useState, useEffect } from "react";
import axios from "axios";
import { SERVER_URL } from "../constants/env";
import setAuthToken from "../utils/setAuthToken";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import truncateWallet from "../utils/truncateWallet";
import { useAccount, useDisconnect } from "wagmi";
import {
  clearProfileCache,
  prefetchProfileImageUrl,
  readCachedProfileAvatar,
  readCachedTwitterUsername,
  writeProfileCache,
} from "../utils/profileImageCache";

const hasStoredAuth = () =>
  Boolean(localStorage.getItem("pnl_token") && localStorage.getItem("pnl_id"));
const UserContextTemplate = {
  userInfo: {
    walletAddress: null,
    walletConnected: false,
    userName: "none",
    userAvatar: "",
    totalspent: 0,
    totalRevenue: 0,
    totalVolume: 0,
    transactionCount: 0,
    sellingRoyaltyFee: 0,
    sellingPlatformFee: 0,
    Pnlvalid: false,
    currentRoundId: null,
    updatePnl: false,
    pnlTime: null,
    isWinner: false,
    isLogin: false,
    twitterPageStatus: false,
    discordServerStatus: false,
    isTwitterConnected: false,
    isDiscordConnected: false,
    discord_name: "",
    twitter_name: "",
    roi: 0,
    dataloading: false,
  },
  walletConnect: () => {},
  logout: () => {},
  loginWithDiscord: () => {},
  reset: () => {},
  updateUser: () => {},
  getMyInfo: () => {},
  setUserInfo: () => {},
  userRank: {
    rank: 0,
    points: 0,
    percentile: undefined,
  },
};
const UserContext = React.createContext(UserContextTemplate);

const UserProvider = ({ children }) => {
  const { disconnect } = useDisconnect();
  const storedSession = hasStoredAuth();
  const [userInfo, setUserInfo] = useState({
    walletAddress: localStorage.getItem("address"),
    walletConnected: false,
    userName: "none",
    userAvatar: storedSession ? readCachedProfileAvatar() : "",
    totalspent: 0,
    totalRevenue: 0,
    totalVolume: 0,
    transactionCount: 0,
    sellingRoyaltyFee: 0,
    sellingPlatformFee: 0,
    Pnlvalid: false,
    currentRoundId: null,
    updatePnl: false,
    pnlTime: null,
    isWinner: false,
    isLogin: storedSession,
    twitterPageStatus: false,
    discordServerStatus: false,
    isTwitterConnected: false,
    isDiscordConnected: false,
    roi: 0,
    dataloading: storedSession,
    twitter_username: storedSession ? readCachedTwitterUsername() : undefined,
  });
  const [showFAQmodalLeaderboard, setShowFAQmodalLeaderboard] = useState(false);
  const [signUpModalShow, setSignUpModalShow] = useState(false);
  const [notificationList, setNotificationList] = useState([]);
  const [showNotificationPopup, setShowNotificationPopup] = useState(false);
  const [userRank, setUserRank] = useState({
    rank: 0,
    points: 0,
    percentile: undefined,
  });

  const notifyError = (message) => {
    toast.error(message, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      className: "toast-error",
    });
  };

  useEffect(() => {
    const jwt = localStorage.getItem("pnl_token");
    const userID = localStorage.getItem("pnl_id");
    const cachedAvatar = readCachedProfileAvatar();
    if (cachedAvatar) prefetchProfileImageUrl(cachedAvatar);
    if (jwt && userID) {
      getMyInfo();
    }
  }, []);

  const logout = async () => {
    disconnect();
    localStorage.removeItem("id");
    localStorage.removeItem("pnl_token");
    clearProfileCache();
    setUserInfo({
      walletAddress: null,
      walletConnected: false,
      userName: "none",
      userAvatar: "",
      islogin: false,
      dataloading: false,
    });
    localStorage.clear();
  };
  const walletConnect = async (Address) => {
    console.log("Attempting wallet login with address:", Address);
    try {
      setUserInfo((currValue) => ({
        ...currValue,
        walletAddress: Address,
        walletConnected: true,
        dataloading: true,
      }));
      localStorage.setItem("address", Address);

      let result = await axios.post(`${SERVER_URL}users/loginwithwallet/`, {
        walletAddress: Address,
      });
      console.log("Login response:", result);
      if (result && result.data.status) {
        if (!result.data.user.signed) {
          setSignUpModalShow(true);
        } else {
          console.log("Login successful, user data:", result);
          setUserInfo((prev) => ({
            ...prev,
            isLogin: true,
            totalspent: result.data.user.totalspent,
            totalRevenue: result.data.user.totalRevenue,
            totalVolume: result.data.user.totalVolume,
            transactionCount: result.data.user.transacationCount,
            sellingRoyaltyFee: result.data.user.sellingRoyaltyFee,
            sellingPlatformFee: result.data.user.sellingplatformFee,
            Pnlvalid: result.data.user.Pnlvalid,
            updatePnl: result.data.user.updatepnl,
            pnlTime: result.data.user.pnlTime,
            isWinner: result.data.user.isWinner,
            twitterPageStatus: result.data.user.is_Twitter_Page_Follwed,
            discordServerStatus: result.data.user.is_Discord_Server_Joined,
            isTwitterConnected: result.data.user.is_Twitter_Connected,
            isDiscordConnected: result.data.user.is_Discord_Connected,
            discord_name: result.data.user.discord_name || "",
            twitter_name: result.data.user.twitter_name || "",
            userAvatar: result.data.user.userAvatar || "",
            roi: result.data.user.roi || 0,
          }));
          writeProfileCache({
            userAvatar: result.data.user.userAvatar,
            twitter_username: result.data.user.twitter_username,
          });
          if (result.data.user.userAvatar) {
            prefetchProfileImageUrl(result.data.user.userAvatar);
          }
          localStorage.setItem("pnl_token", result.data.jwt);
          localStorage.setItem("pnl_id", result.data.user._id);
          await getMyInfo({ showLoading: false });
        }
        return true;
      } else {
        notifyError(result.data?.message || "Login failed");
        return false;
      }
    } catch (error) {
      notifyError(error);
      return false;
    } finally {
      setUserInfo((currValue) => ({
        ...currValue,
        dataloading: false,
      }));
    }
  };

  const getMyInfo = async ({ showLoading = true } = {}) => {
    const jwt = localStorage.getItem("pnl_token");
    const userId = localStorage.getItem("pnl_id");

    if (!userId || !jwt) return false;

    if (showLoading) {
      setUserInfo((currValue) => ({
        ...currValue,
        dataloading: true,
      }));
    }

    let result = await axios
      .get(`${SERVER_URL}users/currentuser`, {
        headers: {
          Authorization: `${jwt}`,
        },
      })
      .then((result) => {
        if (result) {
          const apiUser = result.data.user;
          setUserRank({
            rank: result.data.rank,
            points: result.data.points,
            percentile: result.data.percentile ?? result.data.topPercent ?? result.data.top_percent,
            Gold: result.data.Gold ?? 0,
            Sandisk: result.data.Sandisk ?? 0,
            Pokemon: result.data.Pokemon ?? 0,
          });
          if (apiUser) {
            setUserInfo((currValue) => ({
              ...currValue,
              isLogin: true,
              walletAddress: apiUser.walletAddress ?? currValue.walletAddress,
              totalspent: apiUser.totalspent ?? 0,
              totalRevenue: apiUser.totalRevenue ?? 0,
              totalVolume: apiUser.totalVolume ?? 0,
              transactionCount:
                apiUser.transacationCount ?? apiUser.transactionCount ?? 0,
              sellingRoyaltyFee: apiUser.sellingRoyaltyFee ?? 0,
              sellingPlatformFee:
                apiUser.sellingplatformFee ?? apiUser.sellingPlatformFee ?? 0,
              Pnlvalid: apiUser.Pnlvalid ?? false,
              currentRoundId: apiUser.currentRoundId ?? null,
              updatePnl: apiUser.updatepnl ?? apiUser.updatePnl ?? false,
              pnlTime: apiUser.pnlTime ?? null,
              isWinner: apiUser.isWinner ?? false,
              twitterPageStatus: apiUser.is_Twitter_Page_Follwed ?? false,
              discordServerStatus: apiUser.is_Discord_Server_Joined ?? false,
              isTwitterConnected: apiUser.is_Twitter_Connected ?? false,
              isDiscordConnected: apiUser.is_Discord_Connected ?? false,
              discord_name: apiUser.discord_name ?? "",
              twitter_name: apiUser.twitter_name ?? "",
              userAvatar: apiUser.userAvatar ?? "",
              roi: apiUser.roi ?? 0,
              twitter_username: apiUser.twitter_username,
              firstTransactionDate: apiUser.firstTransactionDate,
            }));
            writeProfileCache({
              userAvatar: apiUser.userAvatar,
              twitter_username: apiUser.twitter_username,
            });
            if (apiUser.userAvatar) {
              prefetchProfileImageUrl(apiUser.userAvatar);
            }
            if (!apiUser.signed) {
              setSignUpModalShow(true);
            }
          }
        }

        return result.data.status;
      })
      .catch((error) => {
        notifyError(error);
        logout();
        return false;
      })
      .finally(() => {
        if (showLoading) {
          setUserInfo((currValue) => ({
            ...currValue,
            dataloading: false,
          }));
        }
      });

    return result;
  };

  return (
    <UserContext.Provider
      value={{
        userInfo,
        walletConnect,
        setUserInfo,
        getMyInfo,
        showFAQmodalLeaderboard,
        setShowFAQmodalLeaderboard,
        setSignUpModalShow,
        signUpModalShow,
        notificationList,
        showNotificationPopup,
        logout,
        userRank,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export { UserContext };
export default UserProvider;
